import { render, staticRenderFns } from "./ClassroomFileModal.vue?vue&type=template&id=3ae53a88&scoped=true"
import script from "./ClassroomFileModal.vue?vue&type=script&lang=js"
export * from "./ClassroomFileModal.vue?vue&type=script&lang=js"
import style0 from "./ClassroomFileModal.vue?vue&type=style&index=0&id=3ae53a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae53a88",
  null
  
)

export default component.exports